__webpack_require__.p = "https://www.reasy.com.mx/";